<template>
    <div id="searchModal" class="d-none w-100">
        <div class="d-md-none title d-flex justify-content-between">
            <div class="d-flex align-items-center fw-bold" v-html="$t('NavBar.iconsModals.search.title')"/>
            <div
            class="d-md-none icons pos-transparent"
            @click="showModal('search')"/>
        </div>
        <div class="search-box d-flex">
            <div class="d-flex w-100 search-border">
                <input ref="search" class="w-100 h-100 border-0" :placeholder="$t('NavBar.iconsModals.search.placeholder')"/>
                <div
                class="icons cross"
                @click="showModal('search')"/>
            </div>
            <div class="icons ok"/>
        </div>
    </div>
</template>

<script>
export default {
    name: "SearchModal",
    props: { showModal: { type: Function, required: true } },
};
</script>

<style lang="scss" scoped>
@import 'bootstrap/scss/_functions.scss';
@import 'bootstrap/scss/_variables.scss';
@import 'bootstrap/scss/_mixins.scss';
@import '@/assets/scss/_colors.scss';
@import '@/assets/scss/_variables.scss';

#searchModal {
    background-color: $primary-color;
    font-size: 1rem;

    input {
        padding: .3rem;

        @include media-breakpoint-up(xl) {
            padding: 1rem;
        }
    }

    .search-box {
        background-color: $primary-color;
        border: .7rem solid $primary-color;
        border-right: 0;
        height: 3rem;

        .icons {
            height: 100% !important;
            width: $header-height / 2;
        }

        @include media-breakpoint-up(md) {
            height: $header-height-md / 2;

            .icons {
                height: 100% !important;
                width: $header-height-md / 2;
            }
        }

        @include media-breakpoint-up(lg) {
            height: $header-height-lg / 2;
            overflow-x: initial;
            border: .85rem solid $primary-color;

            .icons {
                height: 100% !important;
                width: $header-height-lg / 2;
            }
        }

        @include media-breakpoint-up(xxl) {
            height: $header-height-xxl / 2;

            .icons {
                height: 100% !important;
                width: $header-height-xxl / 2;
            }
        }
    }
}
</style>